export default "__VITE_ASSET__CplpJdwg__"